(function() {
  // ---- DEBUG SWITCH ----
  const DEBUG = false; // ← set to false in production

  function log(...args) {
    if (DEBUG) console.log("[Material Debug]", ...args);
  }
  function warn(...args) {
    if (DEBUG) console.warn("[Material Debug]", ...args);
  }
  function error(...args) {
    if (DEBUG) console.error("[Material Debug]", ...args);
  }

  function decodeHtmlEntities(s) {
    if (!s) return s;
    return s.replace(/&quot;/g, '"')
            .replace(/&amp;/g, '&')
            .replace(/&lt;/g, '<')
            .replace(/&gt;/g, '>')
            .replace(/&#39;/g, "'");
  }

  function getVariantIdInput(scope) {
    return (scope || document).querySelector('form[action*="/cart/add"] [name="id"]');
  }

  function getCurrentVariantId(scope) {
    const input = getVariantIdInput(scope);
    const vid = input && input.value ? String(input.value) : null;
    log("getCurrentVariantId:", vid);
    return vid;
  }

  function renderMaterials(materialList, container) {
    log("renderMaterials list:", materialList);
    if (!materialList || !materialList.length) {
      log("No materials — clearing container");
      container.innerHTML = '';
      return;
    }
    const seen = new Set();
    let html = '';
    materialList.forEach((m, i) => {
      log(`item ${i}:`, m);
      if (!m) return;
      const title = (m.title || '').trim();
      const key = title.toLowerCase();
      if (!key || seen.has(key)) {
        log("skip (empty/duplicate):", title);
        return;
      }
      seen.add(key);
      if (title) html += `<strong>${title}</strong>`;
      if (m.description) html += `<div>${m.description}</div>`;
    });
    container.innerHTML = html;
    log("Rendered HTML:", html);
  }

  function initContainer(el) {
    log("initContainer for:", el);

    const rawAttr = el.getAttribute('data-material-map') || '';
    log("data-material-map (raw):", rawAttr);
    const decoded = decodeHtmlEntities(rawAttr);
    log("data-material-map (decoded):", decoded);

    let map = {};
    try {
      map = decoded ? JSON.parse(decoded) : {};
      log("Parsed material map:", map);
    } catch (e) {
      error("JSON.parse failed for data-material-map", e);
      map = {};
    }

    const scope = el.closest('section, .shopify-section, main, body') || document;

    function updateFromScope() {
      const vid = getCurrentVariantId(scope);
      const materials = map[String(vid)] || [];
      log("updateFromScope → vid:", vid, "materials:", materials);
      renderMaterials(materials, el);
    }

    // Initial render
    if (document.readyState === 'loading') {
      log("Waiting for DOMContentLoaded");
      document.addEventListener('DOMContentLoaded', updateFromScope, { once: true });
    } else {
      log("DOM ready, initial update");
      updateFromScope();
    }

    // Theme editor lifecycle
    document.addEventListener('shopify:section:load', updateFromScope);
    document.addEventListener('shopify:section:select', updateFromScope);

    // Variant change events
    document.addEventListener('variant:change', e => {
      log("variant:change", e && e.detail);
      const v = e && e.detail && e.detail.variant;
      if (v) renderMaterials(map[String(v.id)] || [], el);
    });
    document.addEventListener('product:variant-change', e => {
      log("product:variant-change", e && e.detail);
      const v = e && e.detail && e.detail.variant;
      if (v) renderMaterials(map[String(v.id)] || [], el);
    });

    // Form fallback
    const form = scope.querySelector('form[action*="/cart/add"]');
    if (form) {
      log("Attaching form change listener");
      form.addEventListener('change', () => {
        log("form change detected");
        updateFromScope();
      });
    }

    // MutationObserver fallback
    const idInput = getVariantIdInput(scope);
    if (idInput && window.MutationObserver) {
      const mo = new MutationObserver(function(muts) {
        log("MutationObserver mutations:", muts);
        updateFromScope();
      });
      mo.observe(idInput, { attributes: true, attributeFilter: ['value'] });
      log("MutationObserver attached to [name=id]");
    }
  }

  function bootAll() {
    const els = document.querySelectorAll('[data-material-map][data-product-id]');
    log("Found containers:", els);
    els.forEach(initContainer);
  }

  if (document.readyState === 'loading') {
    log("Waiting for DOMContentLoaded (bootAll)");
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    log("DOM already ready (bootAll)");
    bootAll();
  }
})();
